

import React from 'react'
import {Turkish, English} from '../../strings/index';
import detectLanguage from '../common';
import {ServicesContainer, ServicesWrapper, ServicesCard, ServicesIcon, ServicesH1, ServicesH2, ServicesP, MoreContainer, MoreWrapper, MoreText, MoreIcon} from './ServicesElements';
import { FaGithub } from "react-icons/fa";

let Language;
if (detectLanguage() == "en-US")
    Language = English;
else
    Language = Turkish;

const Services = () => {
    return (
        <>
            <ServicesContainer id="projeler">
                <ServicesH1>{Language.Services.main}</ServicesH1>
                
                <ServicesWrapper>

                    <ServicesCard>
                        <ServicesIcon src={Language.Services.others[0].Icon} />
                        <ServicesH2>{Language.Services.others[0].H2}</ServicesH2>
                        <ServicesP>{Language.Services.others[0].P}</ServicesP>
                    </ServicesCard>
                    <ServicesCard>
                        <ServicesIcon src={Language.Services.others[1].Icon} />
                        <ServicesH2>{Language.Services.others[1].H2}</ServicesH2>
                        <ServicesP>{Language.Services.others[1].P}</ServicesP>
                    </ServicesCard>
                    <ServicesCard>
                        <ServicesIcon src={Language.Services.others[2].Icon} />
                        <ServicesH2>{Language.Services.others[2].H2}</ServicesH2>
                        <ServicesP>{Language.Services.others[2].P}</ServicesP>
                    </ServicesCard>

                    
                </ServicesWrapper>                      
                
                <MoreContainer>
                        <MoreWrapper>
    <MoreText>{Language.Services.github}</MoreText>
                            <MoreIcon href="https://github.com/Yusuf-YENICERI/" target="_blank">
                            <FaGithub ></FaGithub>
                            </MoreIcon>
                        </MoreWrapper>
                    </MoreContainer>
                </ServicesContainer>  

        </>
    )
}

export default Services
